import { create } from "zustand";
import { fetchMe, type AdminMe } from "./api";

interface AuthState {
  me: AdminMe | null;
  loaded: boolean;
  refresh: () => Promise<void>;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  me: null,
  loaded: false,
  refresh: async () => {
    try {
      const me = await fetchMe();
      set({ me, loaded: true });
    } catch {
      set({ me: null, loaded: true });
    }
  },
  clear: () => set({ me: null }),
}));
